import type { MailReward } from '@rb/shared/mail/admin-send.types';
import type { MailJobDefinition } from '@rb/shared/mail/job.types';
import { validateMailJobDefinition } from '@rb/shared/mail/job-validation';

export interface RewardGroup {
  rewards: MailReward[];
  accounts: string[];
}

export interface MailFormCommon {
  jobId: string;
  groupType: string;
  titleKey: string;
  contentKey: string;
  ttlDays: number;
}

function rewardsToRecord(rewards: MailReward[]): Record<string, number> {
  const out: Record<string, number> = {};
  for (const r of rewards) out[r.key] = r.amount;
  return out;
}

export function compileGroups(
  common: MailFormCommon,
  groups: RewardGroup[]
): { ok: true; def: MailJobDefinition } | { ok: false; error: string } {
  const rows = groups.flatMap((g) =>
    g.accounts.map((account) => ({ account, rewards: rewardsToRecord(g.rewards) }))
  );
  const def: MailJobDefinition = {
    jobId: common.jobId,
    groupType: common.groupType,
    titleKey: common.titleKey,
    contentKey: common.contentKey,
    ttlDays: common.ttlDays,
    rows,
  };
  try {
    validateMailJobDefinition(def);
  } catch (e) {
    return { ok: false, error: e instanceof Error ? e.message : String(e) };
  }
  return { ok: true, def };
}
